export default __webpack_public_path__ + "836fcd042e2c6606ff0e952effd18288.png";